import { createStore } from 'redux';

import rootReducer from './modules';

const configureStore = (initialState = {}) => {
    const reduxDev = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
    const store = createStore(rootReducer, initialState, reduxDev);
    return store;
};


export default configureStore;


// WEBPACK FOOTER //
// ./src/configureStore.js